import { editorEnum } from 'src/model/editor/editorEnum'

export const templateDataCourse = [
  {
    name: 'Default',
    id: 0,
    path: 'sections',
    font: 'Inter',
    primaryColor: '#015FFB',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/Default.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 1,
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/Default.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(217,99%,49%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
              <p id="introduction-description">Welcome to your learning journey! Gain new skills, expand your knowledge, and explore fresh perspectives. Engage with interactive content designed to help you learn in a meaningful and enjoyable way.</p>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(217,99%,49%);" id="certificate-title">Earn Your Credential</span></h2>
              <p id="certificate-description">Successfully complete this course and earn a badge highlighting your skills and progress. &nbsp;<br><br>Share your accomplishment and take the next step in your journey.</p>
            </div>
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
              </div>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(217,99%,49%)" id="learning_outcomes-title">What You'll Learn</span></h2>
              <p id="learning_outcomes-description"><strong>Gain practical knowledge and hands-on experience, including: </strong></p>
              <ul id="learning_outcomes-items">
                <li>Essential concepts explained in a clear and engaging way</li>
                <li>Real-world applications to deepen understanding </li>
                <li>Step-by-step guidance to build confidence </li>
                <li>Interactive exercises to reinforce learning </li>
                <li>Access to exclusive resources and tools</li>
              </ul>
            </div>
          </div>
        </div><div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2><span style="color:hsl(217,99%,49%);" id="header-title">Table of contents</span></h2>
                    <div class="dynamic-list" data-type="courseOutline2" >
                    </div>
                  </div>
                </div>
              </div>`,
        },
      },
    ],
  },
  {
    name: 'Classic',
    id: 1,
    path: 'sections',
    font: 'Questrial',
    primaryColor: '#001B47',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/classic.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 1,
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/classic.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';">
        <div class="simple-box">
            <div class="column">
                <h2><span style="color:hsl(217, 100%, 14%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
                <p id="introduction-description">Welcome to your learning journey! Gain new skills, expand your knowledge, and explore fresh perspectives. Engage with interactive content designed to help you learn in a meaningful and enjoyable way.</p>
            </div>
        </div>
    </div>

    <div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:#001B47" id="certificate-title">Earn Your Credential</span></h2>
              <p id="certificate-description">Successfully complete this course and earn a badge highlighting your skills and progress. &nbsp;<br><br>Share your accomplishment and take the next step in your journey.</p>
            </div>
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
              </div>
            </div>
          </div>
        </div>

    <div class="simple-box-wrapper">
        <div class="simple-box">
            <div class="column">
                <h2><span style="color:hsl(217, 100%, 14%);" id="learning_outcomes-title">What You'll Learn</span></h2>
                <p id="learning_outcomes-description"><strong>Gain practical knowledge and hands-on experience, including: </strong></p>
                <ul id="learning_outcomes-items">
                    <li>Essential concepts explained in a clear and engaging way</li>
                    <li>Real-world applications to deepen understanding </li>
                    <li>Step-by-step guidance to build confidence </li>
                    <li>Interactive exercises to reinforce learning </li>
                    <li>Access to exclusive resources and tools</li>
                </ul>
            </div>
        </div>
    </div><div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2>Table of contents</h2>
                    <div class="dynamic-list" data-type="courseOutline2" >
                    </div>
                  </div>
                </div>
              </div>`,
        },
      },
    ],
  },
  {
    name: 'Minimal',
    id: 2,
    path: 'sections',
    font: 'Lato',
    primaryColor: '#7346F1',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/minimal.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 1,
          alignment: 'left',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/minimal.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(256, 86%, 61%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
              <p id="introduction-description"><span>Welcome to your learning journey! Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(256, 86%, 61%);" id="certificate-title">Earn Your Credential</span></h2>
              <p id="certificate-description">Successfully complete this course and earn a badge highlighting your skills and progress. &nbsp;<br><br>Share your accomplishment and take the next step in your journey.</p>
            </div>
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
              </div>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(256, 86%, 61%);"id="learning_outcomes-title">What You'll Learn</span></h2>
              <p id="learning_outcomes-description"><strong>Gain practical knowledge and hands-on experience, including:</strong></p>
              <ul id="learning_outcomes-items">
                <li>Essential concepts explained in a clear and engaging way</li>
                <li>Real-world applications to deepen understanding</li>
                <li>Step-by-step guidance to build confidence</li>
                <li>Interactive exercises to reinforce learning</li>
                <li>Access to exclusive resources and tools</li>
              </ul>
            </div>
          </div>
        </div><div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2><span style="color:hsl(256, 86%, 61%);"id="header-title">Table of contents</span></h2>
                    <div class="dynamic-list" data-type="courseOutline2" >
                    </div>
                  </div>
                </div>
              </div>`,
        },
      },
    ],
  },
  {
    name: 'Elegant',
    id: 3,
    path: 'sections',
    font: 'Barlow',
    primaryColor: '#947100 ',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/elegant.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 1,
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/elegant.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(46, 100%, 29%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p id="introduction-description"><span>Welcome to your learning journey! Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(46, 100%, 29%);" id="certificate-title">Earn Your Credential</span></h2>
            <p id="certificate-description">Successfully complete this course and earn a badge highlighting your skills and progress. &nbsp;<br><br>Share your accomplishment and take the next step in your journey.</p>
          </div>
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url(https://cdn.minicoursegenerator.com/test/images/suleymanayki638633765662296072/80c72c1f-c8e0-4bad-9503-c7f67c6bdea9.png);background-position:'';background-size:'';" background-image="https://cdn.minicoursegenerator.com/test/images/suleymanayki638633765662296072/80c72c1f-c8e0-4bad-9503-c7f67c6bdea9.png" background-color="" background-type="image" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(46, 100%, 29%);" id="learning_outcomes-title">What You'll Learn</span></h2>
            <p id="learning_outcomes-description"><span style="color:hsl(0, 0%, 100%);"><strong>Gain practical knowledge and hands-on experience, including:</strong></span></p>
            <ul id="learning_outcomes-items" style="color:hsl(0, 0%, 100%);">
              <li><span style="color:hsl(0, 0%, 100%);">Essential concepts explained in a clear and engaging way</span></li>
              <li><span style="color:hsl(0, 0%, 100%);">Real-world applications to deepen understanding</span></li>
              <li><span style="color:hsl(0, 0%, 100%);">Step-by-step guidance to build confidence</span></li>
              <li><span style="color:hsl(0, 0%, 100%);">Interactive exercises to reinforce learning</span></li>
              <li><span style="color:hsl(0, 0%, 100%);">Access to exclusive resources and tools</span></li>
            </ul>
          </div>
        </div>
      </div><div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2>Table of contents</h2>
                    <div class="dynamic-list" data-type="courseOutline2" >
                    </div>
                  </div>
                </div>
              </div>`,
        },
      },
    ],
  },
  {
    name: 'Horizon',
    id: 4,
    path: 'sections',
    primaryColor: '#273F2B',
    font: 'DM Sans',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/horizon.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 1,
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/horizon.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h1 style="text-align:center;"><span style="color:hsl(132, 25%, 20%);" id="introduction-title">Discover, Learn, and Grow</span></h1>
            <p id="introduction-description"><span style="color:hsl(132, 25%, 20%);">Welcome to your learning journey! Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(132, 25%, 20%);" id="learning_outcomes-title">What You'll Learn</span></h2>
            <hr>
            <p id="learning_outcomes-description"><span style="color:hsl(132, 25%, 20%);"><strong>Gain practical knowledge and hands-on experience, including:</strong></span></p>
            <ul id="learning_outcomes-items">
              <li><span style="color:hsl(132, 25%, 20%);">Essential concepts explained in a clear and engaging way</span></li>
              <li><span style="color:hsl(132, 25%, 20%);">Real-world applications to deepen understanding</span></li>
              <li><span style="color:hsl(132, 25%, 20%);">Step-by-step guidance to build confidence</span></li>
              <li><span style="color:hsl(132, 25%, 20%);">Interactive exercises to reinforce learning</span></li>
              <li><span style="color:hsl(132, 25%, 20%);">Access to exclusive resources and tools</span></li>
            </ul>
          </div>
        </div>
      </div>
      
      <div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2>Table of contents</h2>
                    <div class="dynamic-list" data-type="courseOutline2" >
                    </div>
                  </div>
                </div>
              </div>`,
        },
      },
    ],
  },
  {
    name: 'Vibrant',
    id: 5,
    path: 'sections',
    font: 'Manrope',
    primaryColor: '#000000',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/vibrant.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 1,
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/vibrant.jpg',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:#dffd6e;background-position:'';background-size:'';" background-image="" background-color="#dffd6e" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h1 style="text-align:center;"><span style="color:hsl(0, 0%, 0%);" id="introduction-title">Discover, Learn, and Grow</span></h1>
            <p style="text-align:center;" id="introduction-description"><span>Welcome to your learning journey! This is your opportunity to gain valuable new skills, expand your knowledge, and explore fresh perspectives that can transform the way you think and grow. Through engaging, interactive content, you'll immerse yourself in a dynamic learning experience designed to be both meaningful and enjoyable.&nbsp;</span></p>
            <p style="text-align:center;"><span>Whether you're looking to deepen your expertise, develop practical abilities, or simply broaden your horizons, this journey will empower you with the insights and tools you need to succeed. Get ready to learn, explore, and evolve!</span></p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 0%);" id="certificate-title">Earn Your Credential</span></h2>
            <p id="certificate-description">Successfully complete this course and earn a badge highlighting your skills and progress. &nbsp;<br><br>Share your accomplishment and take the next step in your journey.</p>
          </div>
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 0%);" id="learning_outcomes-title">What You'll Learn</span></h2>
            <p id="learning_outcomes-description"><strong>Gain practical knowledge and hands-on experience, including:</strong></p>
            <ul id="learning_outcomes-items">
              <li>Essential concepts explained in a clear and engaging way</li>
              <li>Real-world applications to deepen understanding</li>
              <li>Step-by-step guidance to build confidence</li>
              <li>Interactive exercises to reinforce learning</li>
              <li>Access to exclusive resources and tools</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2>Table of contents</h2>
                    <div class="dynamic-list" data-type="courseOutline2" >
                    </div>
                  </div>
                </div>
              </div>
      `,
        },
      },
    ],
  },
  {
    name: 'Discover',
    id: 6,
    path: 'sections',
    font: 'Nunito Sans',
    primaryColor: '#0077B6',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/discover.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 1,
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/discover.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span>🌍 </span><span style="color:hsl(201, 100%, 36%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p style="text-align:center;" id="introduction-description"><span style="color:hsl(201, 100%, 36%);">Welcome to your learning journey! Gain new skills, expand your knowledge, and explore fresh perspectives. Engage with interactive content designed to help you learn in a meaningful and enjoyable way.</span></p>
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/world-map.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(201, 100%, 36%);" id="certificate-title">Earn Your Credential</span></h2>
            <p id="certificate-description">Successfully complete this course and earn a badge highlighting your skills and progress. &nbsp;<br><br>Share your accomplishment and take the next step in your journey.</p>
          </div>
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(201, 100%, 36%);" id="learning_outcomes-title">🗺️ What You'll Learn</span></h2>
            <p id="learning_outcomes-description"><strong>Gain practical knowledge and hands-on experience, including:</strong></p>
            <ul id="learning_outcomes-items">
              <li>Essential concepts explained in a clear and engaging way</li>
              <li>Real-world applications to deepen understanding</li>
              <li>Step-by-step guidance to build confidence</li>
              <li>Interactive exercises to reinforce learning</li>
              <li>Access to exclusive resources and tools</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2><span style="color:hsl(201, 100%, 36%);" id="header-title">Table of contents</span></h2>
                    <div class="dynamic-list" data-type="courseOutline2" >
                    </div>
                  </div>
                </div>
              </div>
      `,
        },
      },
    ],
  },
  {
    name: 'Grow',
    id: 7,
    path: 'sections',
    font: 'Sora',
    primaryColor: '#0077B6',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/grow.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 1,
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/grow.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-image:url(https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/grow-discover.jpg);background-position:top-center;background-size:cover;" background-image="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/grow-discover.jpg" background-color="" background-type="" background-size="cover" size-type="SCALE_TO_FILL" use-image-overlay="" background-position="top-center" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color=""><div class="simple-box"><div class="column" flex-size="undefined"><h1 style="text-align:center;">&nbsp;</h1><h1 style="text-align:center;"><span style="color:hsl(0,0%,0%);"><span id="introduction-title">Discover, Learn, and Grow</span></span></h1><p style="text-align:center;" id="introduction-description"><span>Welcome to your learning journey!&nbsp;</span></p><p style="text-align:center;"><span>Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p><p style="text-align:center;">&nbsp;</p></div></div></div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 0%);" id="certificate-title">Earn Your Credential</span></h2>
            <p id="certificate-description">Successfully complete this course and earn a badge highlighting your skills and progress. &nbsp;<br><br>Share your accomplishment and take the next step in your journey.</p>
          </div>
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:#F5F7FA;background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 0%);" id="learning_outcomes-title">What You'll Learn</span></h2>
            <p id="learning_outcomes-description"><strong>Gain practical knowledge and hands-on experience, including:</strong></p>
            <ul id="learning_outcomes-items">
              <li>Essential concepts explained in a clear and engaging way</li>
              <li>Real-world applications to deepen understanding</li>
              <li>Step-by-step guidance to build confidence</li>
              <li>Interactive exercises to reinforce learning</li>
              <li>Access to exclusive resources and tools</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2>Table of contents</h2>
                    <div class="dynamic-list" data-type="courseOutline2" >
                    </div>
                  </div>
                </div>
              </div>
      `,
        },
      },
    ],
  },
  {
    name: 'Podcast',
    id: 8,
    path: 'sections',
    font: 'Inter',
    primaryColor: '#FF6B00',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/podcast.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 1,
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/podcast.jpg',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:#ffffff;background-image:none;background-position:center;background-size:cover;" background-image="" background-color="#ffffff" background-type="color" background-size="cover" size-type="cover" use-image-overlay="false" background-position="center" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(25, 100%, 50%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p id="introduction-description"><span style="color:hsl(222, 36%, 11%);">Welcome to your learning journey! Gain new skills, expand your knowledge, and explore fresh perspectives. Engage with interactive content designed to help you learn in a meaningful and enjoyable way.</span></p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:#2a2e36;background-image:none;background-position:center;background-size:cover;" background-image="" background-color="#2a2e36" background-type="color" background-size="cover" size-type="cover" use-image-overlay="false" background-position="center" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(25, 100%, 50%);" id="learning_outcomes-title">What You'll Learn</span></h2>
            <p id="learning_outcomes-description"><span style="color:hsl(0, 0%, 100%);">I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</span></p>
            <div class="column-header">
              <ul id="learning_outcomes-items">
                <li><span style="color:hsl(0, 0%, 100%);">Understand what makes your podcast unique and how to find your niche. Learn how to communicate your message effectively and engage your audience.</span></li>
                <li><span style="color:hsl(0, 0%, 100%);">Learn how to plan and outline your podcast episodes for maximum impact. Discover different formats and storytelling techniques.</span></li>
                <li><span style="color:hsl(0, 0%, 100%);">Master the technical aspects of podcasting. From setting up your recording space to editing your audio like a pro.</span></li>
              </ul>
            </div>
            <div class="column-header">
              <ul>
                <li><span style="color:hsl(0, 0%, 100%);">Explore the must-have tools for quality podcast production. From microphones to editing software, get recommendations for every budget.</span></li>
                <li><span style="color:hsl(0, 0%, 100%);">Create a strong brand identity and promote your podcast effectively. Understand SEO, social media strategies, and audience growth techniques.</span></li>
                <li><span style="color:hsl(0, 0%, 100%);">Learn how to publish your podcast on major platforms and explore monetization strategies such as sponsorships, memberships, and more.</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2>Table of contents</h2>
                    <div class="dynamic-list" data-type="courseOutline2" >
                    </div>
                  </div>
                </div>
              </div>
      `,
        },
      },
    ],
  },
  {
    name: 'Divine',
    id: 9,
    path: 'sections',
    font: 'Lato',
    primaryColor: '#c3a169 ',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/divine.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 1,
          alignment: 'left',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/divine.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(37, 43%, 59%);" id="introduction-title">Embrace Wisdom, Find Your Path</span></h2>
            <p id="introduction-description"><span>Growth begins with curiosity and a willingness to explore new perspectives. Whether you're seeking personal transformation, professional development, or a deeper understanding of the world around you, this collection is designed to guide you every step of the way.</span></p>
            <p><span>Through insightful lessons, practical strategies, and timeless wisdom, you'll gain the clarity and confidence to navigate your journey with purpose and fulfillment.</span></p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(37, 43%, 59%);" id="certificate-title">Earn Your Sacred Recognition</span></h2>
            <p id="certificate-description"><span>Successfully complete this course and earn a badge honoring your dedication to learning and self-discovery.&nbsp;</span></p>
          </div>
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="color:hsl(37, 43%, 59%);" id="learning_outcomes-title"><span>What You'll Discover</span></h2>
            <p id="learning_outcomes-description"><span>Journey through knowledge that enlightens and inspires, including:</span></p>
            <ul id="learning_outcomes-items">
              <li><span>Profound teachings from various traditions</span></li>
              <li><span>Meditative and reflective practices</span></li>
              <li><span>Insights into self-awareness and personal growth</span></li>
              <li><span>Stories and wisdom passed through generations</span></li>
              <li><span>Practical tools for mindful living</span></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2><span style="color:hsl(37, 43%, 59%);" id="header-title">Table of contents</span></h2>
                    <div class="dynamic-list" data-type="courseOutline2" >
                    </div>
                  </div>
                </div>
              </div>
      `,
        },
      },
    ],
  },
  {
    name: 'Playful',
    id: 10,
    path: 'sections',
    font: 'Barlow',
    primaryColor: '#708800',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/playful.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 1,
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/playful.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 17%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
              <p style="text-align:center;" id="introduction-description"><span style="color:hsl(0, 0%, 17%);">Welcome to your learning journey! This is your opportunity to gain valuable new skills, expand your knowledge, and explore fresh perspectives that can transform the way you think and grow. Through engaging, interactive content, you'll immerse yourself in a dynamic learning experience designed to be both meaningful and enjoyable.</span></p>
              <p style="text-align:center;"><span style="color:hsl(0, 0%, 17%);">Whether you're looking to deepen your expertise, develop practical abilities, or simply broaden your horizons, this journey will empower you with the insights and tools you need to succeed. Get ready to learn, explore, and evolve!</span></p>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(0, 0%, 17%);" id="certificate-title">Earn Your Credential</span></h2>
              <p id="certificate-description"><span>Complete all courses in this collection and receive a certificate recognizing your dedication and achievement.&nbsp;</span><br><br><span style="color:hsl(0, 0%, 17%);">Share your accomplishment and take the next step in your journey.</span></p>
            </div>
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
              </div>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(0, 0%, 17%);" id="learning_outcomes-title">What You'll Learn</span></h2>
              <p id="learning_outcomes-description"><span style="color:hsl(0, 0%, 17%);"><strong>Gain practical knowledge and hands-on experience, including:</strong></span></p>
              <ul id="learning_outcomes-items">
                <li><span style="color:hsl(0, 0%, 17%);">Essential concepts explained in a clear and engaging way</span></li>
                <li><span style="color:hsl(0, 0%, 17%);">Real-world applications to deepen understanding</span></li>
                <li><span style="color:hsl(0, 0%, 17%);">Step-by-step guidance to build confidence</span></li>
                <li><span style="color:hsl(0, 0%, 17%);">Interactive exercises to reinforce learning</span></li>
                <li><span style="color:hsl(0, 0%, 17%);">Access to exclusive resources and tools</span></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2>Table of contents</h2>
                    <div class="dynamic-list" data-type="courseOutline2" >
                    </div>
                  </div>
                </div>
              </div>
        `,
        },
      },
    ],
  },
  {
    name: 'Dynamic',
    id: 11,
    path: 'sections',
    primaryColor: '#116CFF',
    font: 'Saira',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/dynamic.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 1,
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/dynamic.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 17%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p style="text-align:center;" id="introduction-description"><span style="color:hsl(0, 0%, 17%);">Welcome to your learning journey! Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p>
            <div class="video-wrapper" id="intro-video">
              <video class="video-player" src="https://player.vimeo.com/progressive_redirect/playback/1038160884/rendition/720p/file.mp4?loc=external&amp;log_user=0&amp;signature=e3371f1c844e5717ebef8396e458b401366fbbb67b1778a783d56e38494ea377" aspectratio="16/9" controls="true" controlslist="nodownload">&nbsp;</video>
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 17%);" id="certificate-title">Earn Your Credential</span></h2>
            <p id="certificate-description"><span style="color:hsl(0, 0%, 17%);">Successfully complete this course and earn a badge highlighting your skills and progress. &nbsp;</span><br><br><span style="color:hsl(0, 0%, 17%);">Share your accomplishment and take the next step in your journey.</span></p>
          </div>
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 17%);" id="learning_outcomes-title">What You'll Learn</span></h2>
            <p id="learning_outcomes-description"><strong>Gain practical knowledge and hands-on experience, including:</strong></p>
            <ul id="learning_outcomes-items">
              <li>Essential concepts explained in a clear and engaging way</li>
              <li>Real-world applications to deepen understanding</li>
              <li>Step-by-step guidance to build confidence</li>
              <li>Interactive exercises to reinforce learning</li>
              <li>Access to exclusive resources and tools</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2>Table of contents</h2>
                    <div class="dynamic-list" data-type="courseOutline2" >
                    </div>
                  </div>
                </div>
              </div>
      `,
        },
      },
    ],
  },
  {
    name: 'Ascent',
    id: 12,
    path: 'sections',
    font: 'Inter',
    primaryColor: '#131313',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/ascent.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 1,
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/ascent.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:#222424;background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="#292a2b" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(50, 100%, 50%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p id="introduction-description"><span style="color:hsl(0, 0%, 100%);">Welcome to your learning journey! Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 7%);" id="certificate-title">Earn Your Credential</span></h2>
            <p id="certificate-description"><span style="color:hsl(0, 0%, 7%);">Successfully complete this course and earn a badge highlighting your skills and progress. &nbsp;</span><br><br><span style="color:hsl(0, 0%, 7%);">Share your accomplishment and take the next step in your journey.</span></p>
          </div>
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:#FFD400;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 7%);" id="learning_outcomes-title">What You'll Learn</span></h2>
            <p id="learning_outcomes-description"><span style="color:hsl(0, 0%, 7%);">Gain practical knowledge and hands-on experience, including:</span></p>
          </div>
          <div class="column" flex-size="undefined">
            <ul id="learning_outcomes-items">
              <li><span style="color:hsl(0, 0%, 7%);">Essential concepts explained in a clear and engaging way</span></li>
              <li><span style="color:hsl(0, 0%, 7%);">Real-world applications to deepen understanding</span></li>
              <li><span style="color:hsl(0, 0%, 7%);">Step-by-step guidance to build confidence</span></li>
              <li><span style="color:hsl(0, 0%, 7%);">Interactive exercises to reinforce learning</span></li>
              <li><span style="color:hsl(0, 0%, 7%);">Access to exclusive resources and tools</span></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2>Table of contents</h2>
                    <div class="dynamic-list" data-type="courseOutline2" >
                    </div>
                  </div>
                </div>
              </div>
      `,
        },
      },
    ],
  },
  {
    name: 'Organic',
    id: 13,
    path: 'sections',
    font: 'Georama',
    primaryColor: '#696D2C',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/organic.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 1,
          alignment: 'left',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/organic.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:#fff8ed;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#fff8ed" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(64, 42%, 30%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p id="introduction-description"><span style="color:hsl(64, 42%, 30%);"><strong>Welcome to your learning journey!</strong> Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(64, 42%, 30%);" id="certificate-title">Earn Your Credential</span></h2>
            <p id="certificate-description"><span style="color:hsl(64, 42%, 30%);">Successfully complete this course and earn a badge highlighting your skills and progress. &nbsp;</span><br><br><span style="color:hsl(64, 42%, 30%);">Share your accomplishment and take the next step in your journey.</span></p>
          </div>
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(64, 42%, 30%);" id="learning_outcomes-title">What You'll Learn</span></h2>
            <p id="learning_outcomes-description"><span style="color:hsl(64, 42%, 30%);"><strong>Gain practical knowledge and hands-on experience, including:</strong></span></p>
            <ul id="learning_outcomes-items">
              <li><span style="color:hsl(64, 42%, 30%);">Essential concepts explained in a clear and engaging way</span></li>
              <li><span style="color:hsl(64, 42%, 30%);">Real-world applications to deepen understanding</span></li>
              <li><span style="color:hsl(64, 42%, 30%);">Step-by-step guidance to build confidence</span></li>
              <li><span style="color:hsl(64, 42%, 30%);">Interactive exercises to reinforce learning</span></li>
              <li><span style="color:hsl(64, 42%, 30%);">Access to exclusive resources and tools</span></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2><span style="color:hsl(64, 42%, 30%);" id="header-title">Table of contents</span></h2>
                    <div class="dynamic-list" data-type="courseOutline2" >
                    </div>
                  </div>
                </div>
              </div>
      `,
        },
      },
    ],
  },
  {
    name: 'Momentum',
    id: 14,
    path: 'sections',
    font: 'Space Grotesk',
    primaryColor: '#0453F1',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/momentum.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 1,
          alignment: 'left',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/momentum.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(220, 97%, 48%);" id="intro-subtitle">Dive in, Explore more</span></h2>
              <p id="introduction-description"><span><strong>Welcome to your learning journey!</strong> This is your opportunity to gain valuable new skills, expand your knowledge, and explore fresh perspectives that can transform the way you think and grow.&nbsp;</span></p>
              <p><span>Through engaging, interactive content, you'll immerse yourself in a dynamic learning experience designed to be both meaningful and enjoyable. Whether you're looking to deepen your expertise, develop practical abilities, or simply broaden your horizons, this journey will empower you with the insights and tools you need to succeed. Get ready to learn, explore, and evolve!</span></p>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(220, 97%, 48%);" id="certificate-title">Earn Your Credential</span></h2>
              <p id="certificate-description">Successfully complete this course and earn a badge highlighting your skills and progress. &nbsp;<br><br>Share your accomplishment and take the next step in your journey.</p>
            </div>
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
              </div>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(217,99%,49%);" id="learning_outcomes-title">What You'll Learn</span></h2>
              <p id="learning_outcomes-description"><strong>Gain practical knowledge and hands-on experience, including:</strong></p>
              <ul id="learning_outcomes-items">
                <li>Essential concepts explained in a clear and engaging way</li>
                <li>Real-world applications to deepen understanding</li>
                <li>Step-by-step guidance to build confidence</li>
                <li>Interactive exercises to reinforce learning</li>
                <li>Access to exclusive resources and tools</li>
              </ul>
            </div>
          </div>
        </div><div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2><span style="color:hsl(217,99%,49%);" id="header-title">Table of contents</span></h2>
                    <div class="dynamic-list" data-type="courseOutline2" >
                    </div>
                  </div>
                </div>
              </div>`,
        },
      },
    ],
  },
]
